export const getSumbitPromise = (result) =>
  result
    ? result.then
      ? result
      : result.promise && result.promise.then
      ? result.promise
      : null
    : null
